import { getGrpcPromise } from '@monorepo/grpc';
import { PricingService } from '@spilca/order_ts/v1/order_web/pricing_web_pb_service';
import { ListPricingQuantityTypeRequest } from '@spilca/order_ts/v1/order/model_pricing_pb';
import { pricingFilterConstructor } from '@monorepo/pricing';

const getPricingQuantityTypes = (d: any) => {
  const getQuantityType = getGrpcPromise(
    PricingService.ListPricingQuantityType
  );
  const [, params] = d.queryKey;
  const dealFilter = pricingFilterConstructor(params, d.active);
  const request = new ListPricingQuantityTypeRequest();
  request.setFilter(dealFilter);
  return getQuantityType(request);
};

export default getPricingQuantityTypes;
